<script>
import { claimRedEnvelope } from "api/wechatSDK";
import { claimWechatPointsApi, checkWeChatRedPacketClaimApi } from "api/onLine";
import { getCouponsByIdApi, getCoupons } from "api/user";
import { Dialog } from 'vant';

export default {
  props: {},
  data(){
    return {
      couponId: undefined,
      couponsBalance: 0,
      couponsBalanceSum: 0,
      amount: '0',
      showNameDialog: false,
      weChatName: '',
      canClaimAmount: 0,
      couponsList: [],
      couponsWechatRedpacketRebate: 0
    }
  },
  async created() {
    await this.getCouponsList()
    if(this.couponsList){
      let list = this.couponsList.filter(item => item?.couponsCategory?.includes("weChatPoints"))
      if(list){
        this.couponId = list[0].couponsId
        this.couponsBalanceSum = Number((list.reduce((acc, item) => acc + Number(item.couponsBalance), 0)).toFixed(3))
      }
    }
    this.getCouponsById()
    this.$store.commit("setPageLoading", true);
  },
  methods: {
    dialogHandle(title, message){
      return Dialog.confirm({
        title: title,
        message: message,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => true).catch(() => false);
    },
    isMobileDevice(){
      const userAgent = navigator.userAgent.toLowerCase();
      
      // 判断是否是微信 WebView
      const isWechat = /micromessenger/.test(userAgent);
      
      // 判断是否为 PC 端微信，PC端微信浏览器的 User-Agent 里有 Windows 或 Mac 标识
      const isPCWechat = isWechat && (userAgent.includes('windows') || userAgent.includes('macintosh'));
      
      // 判断是否为触摸设备
      const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
      const isMobileWidth = window.innerWidth <= 768;

      // 如果是微信 WebView，但不是 PC 端微信，则返回 true（认为是手机）
      return (isWechat && !isPCWechat && (isTouchDevice || isMobileWidth));
    },
    toFixed(amount){
      const str = amount.toString();
      const dotIndex = str.indexOf('.');
      if (dotIndex === -1 || str.slice(dotIndex + 1).length <= 2) {
        return Number(str);
      }
      return Number(str.slice(0, dotIndex + 3));
    },
    async getCouponsById() {
      if(!this.couponId) return
      //券余额
      await getCouponsByIdApi(this.couponId).then(({data, status}) => {
        if(status == 200){
          this.couponsBalance = data.couponsBalance
          this.couponsProductId = data.couponsProductId
          //如果没有红包折扣，使用转让折扣
          this.couponsWechatRedpacketRebate = data.couponsWechatRedpacketRebate ?? data.couponsRecoveryRebate
        }
      })
      const {status, data} = await checkWeChatRedPacketClaimApi()
      if(status == 200){
        //今日剩余可兑换零钱额度 999 - 已兑换额度
        this.canClaimAmount = 999 - data.claimAmount
        if(this.canClaimAmount < 0) this.canClaimAmount = 0
        //卡券剩余零钱 = 卡券额度 * 卡券折扣
        let redPacketBalance = this.toFixed(this.couponsBalance * this.couponsWechatRedpacketRebate)
        if(redPacketBalance >= this.canClaimAmount){
          this.amount = Number((this.canClaimAmount / this.couponsWechatRedpacketRebate).toFixed(2));
        }else{
          this.amount = this.couponsBalance
        }
      }else{
        alert("服务繁忙！");
      }
    },
    handleBeforeClose(action, done) {
      if (action === 'confirm') {
        // 阻止默认关闭，由 handleConfirm 决定是否关闭
        done(false);
      } else {
        done(); // 点击取消正常关闭
      }
    },
    verifyFrom(){
      if(!this.couponId){
        alert("没有可用的券!");
        return false;
      }
      if(!this.isMobileDevice()){
        alert("该功能现只支持移动端操作!");
        return false;
      }
      if(Number(this.canClaimAmount) == 0){
        alert("今日已达兑换上限");
        return false
      }
      if(Number(this.couponsBalance) == 0){
        alert("余额不足");
        return false
      }

      const packet = this.toFixed(this.amount * this.couponsWechatRedpacketRebate)
      if(packet < 0.3){
        alert("零钱最低 0.3 元");
        return false
      }
      if(Number(this.couponsBalance) < Number(this.amount)){
        alert("券余额不足，余额为" + this.couponsBalance);
        return false
      }
      this.showNameDialog = true
    },
    async claimHandle() {
      if(this.weChatName == undefined || this.weChatName == ''){
        alert("姓名不能为空!");
        return false;
      }
      this.showNameDialog = false
      // let res = await this.dialogHandle('提示','确定消耗' + this.amount + ' 权益积分兑换 ' + packet +' 微信零钱吗？')
      // if(!res) return

      let params = {
        couponId: this.couponId,
        productNo: '1288',
        amount: this.amount,
        weChatName: this.weChatName
      }
      const { status, message } = await claimWechatPointsApi(params)
      if(status == 200){
        this.$successSync('兑换成功', () => {
            this.$push({ path: "/coupons" });
        });
      }else{
        alert(message);
      }

      // const { data, status, message } = await claimWechatPointsApi(params)
      // if(!status == 200 || !data || !data.mchId || !data.packageInfo) {
      //   this.$push({ path: "/orders?type=-1" });
      //   return
      // }
      // if(status == 200){
      //   claimRedEnvelope(data.mchId, data.packageInfo, data.orderNo)
      // }else{
      //   alert(message);
      // }
    },
    async getCouponsList() {
      await getCoupons(0).then((res) => {
        if (res.status === 200) {
          if (
            res.data != undefined &&
            res.data != null &&
            res.data.records.length > 0
          ) {
            this.couponsList = res.data.records.filter(i => i?.couponsCategory?.includes("weChatPoints"))
          } else {
            this.couponsList = [];
          }
        } else {
          this.$error(res.message);
        }
      });
    }
  }
}
</script>
<template>
  <div class="backgImg">
    <div class="balance-container">
      <span class="balance-label">余额:</span>
      <span class="balance-value">{{ couponsBalanceSum }}</span>
    </div>
    <div style="padding-top: 40vh">
      <div class="redPacketImg">
        <div class="priceSty" style="font-size: 26px; padding:60px 0 16px 0;">
          {{toFixed(amount * couponsWechatRedpacketRebate)}}元
          <span style="font-size: 18px; display: block;">
            ￥{{ amount }}
          </span>
        </div>
        <div class="inline-block but" @click="verifyFrom()">
          立即兑换
        </div>
      </div>
    </div>
    <div class="promptSty">
      温馨提示:微信零钱最低 0.3 元，单笔限额不能超过999元，单人单日限额999。
    </div>
    <van-dialog
      v-model="showNameDialog"
      title="兑换确认"
      :before-close="handleBeforeClose"
      @confirm="claimHandle()"
      show-cancel-button
      :lazy-render="false"
    >
      <div class="flex-align withdraw">
        <van-field v-model="weChatName" class="custom-placeholder" autofocus placeholder="请填写您的姓名" />
        <div style="font-size: 16px; text-align: center; width: 90%; padding: 0 5% 8px;">
          {{ '确定消耗' + amount + ' 权益积分兑换 ' + toFixed(amount * couponsWechatRedpacketRebate) +' 微信零钱吗？' }}
          （请确保输入的姓名与当前微信实名一致，若不一致将无法收取零钱）
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<style scoped>
.backgImg{
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  height: 80vh;
  background-size: 100% 100%;
  background-repeat:no-repeat;
  background-position: center;
  background-image: url("../../../assets/weChatRedPacketBackground.png");
}

.redPacketImg{
  display: grid;
  justify-items: center;
  width:115px;
  height:130px;
  background-size: 100% 100%;
  background-repeat:no-repeat;
  background-position: center;
  background-image: url("../../../assets/redPacket.png");
}

.but{
  background-color: #e9c534;
  border: 1px solid black;
  font-size: clamp(14px, 4vw, 18px);
  font-weight: bold;
  width: clamp(60px, 20vw, 80px);
  height: clamp(26px, 8vw, 34px);
  border-radius: clamp(13px, 4vw, 17px);
  line-height: clamp(26px, 8vw, 34px);
  text-align: center;
  padding: 0px clamp(8px, 2.5vw, 12px);
  display: inline-block;
  color: black;
}

.priceSty{
  color: #ffffff;
  text-align: center;
  font-family: fangsong;
}

.balance-container{
  position: absolute;
  top: 5vh;
  left: 25vw;
  display: flex;
  align-items: baseline;
}

.balance-label{
  color: #ffffff;
  font-family: cursive;
  font-size: clamp(14px, 5vw, 24px);
}

.balance-value{
  color: #ffffff;
  font-size: clamp(14px, 5vw, 24px);
  margin-left: 2px;
}


.promptSty{
  width: 70vw;
  position: absolute;
  bottom: 3vh;
  font-size: clamp(11px, 3.2vw, 16px);
  text-align: center;
  font-weight: bold;
  color: black;
  line-height: 1.5;
}

@media screen and (min-width: 320px) and (max-width: 375px) {
  .balance-label,
  .balance-value {
    font-size: clamp(14px, 5.5vw, 22px);
  }
  .promptSty {
    font-size: clamp(11px, 3.5vw, 14px);
  }
}

@media screen and (min-width: 376px) and (max-width: 414px) {
  .balance-label,
  .balance-value {
    font-size: clamp(16px, 5vw, 24px);
  }
  .promptSty {
    font-size: clamp(12px, 3.2vw, 15px);
  }
}

@media screen and (min-width: 415px) and (max-width: 768px) {
  .balance-label,
  .balance-value {
    font-size: clamp(18px, 4.5vw, 28px);
  }
  .promptSty {
    font-size: clamp(13px, 2.8vw, 18px);
    width: 60vw;
  }
}

@media screen and (min-width: 769px) {
  .balance-label,
  .balance-value {
    font-size: clamp(20px, 3vw, 32px);
  }
  .promptSty {
    font-size: clamp(14px, 2vw, 20px);
    width: 50vw;
  }
}

/deep/ .van-field__control {
  padding-left: 10px;
}
.van-cell{
  position: initial;
}
</style>